
import {useState, useEffect} from 'react';
import {useCookies} from 'react-cookie';

const setters = [];

export default function useUser() {
  const [cookies, setCookie, removeCookie] = useCookies(['user']);
  const [user, userSetter] = useState(
    cookies.username
      ? {
        username: cookies.username,
        type: cookies.type,
        userToken: cookies.userToken,
      }
      : null
  );

  useEffect(() => {
    setters.push(userSetter);
    return () => setters.splice(setters.indexOf(userSetter), 1);
  });

  const setUser = (user, rememberChecked = null) => {
    if (!user) {
      ['username', 'userToken', 'type'].forEach(cookieName => {
        removeCookie(cookieName, {path: '/'});
      });
    } else {
      const expires = rememberChecked ? new Date(Date.now() + 30 * 24 * 3600 * 1000) : null;
      Object.entries(user).forEach(([key, value]) => {
        setCookie(key, value, {path: '/', expires});
      });
    }
    setters.forEach(setter => setter(user));
  };

  return {
    ...user,
    setUser,
  };
}
